import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=10b47e12&scoped=true&"
import script from "./SidebarMenu.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=10b47e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b47e12",
  null
  
)

export default component.exports